/* src/app/preview-training/preview-training.component.scss */
.table-container {
  background-color: #3d3f47;
  border-radius: 20px;
  width: 100%;
  padding: 0 40px 10px 40px;
}
.table-container .mat-mdc-cell {
  color: white;
}
.table-container .mat-mdc-cell a {
  text-decoration: none;
}
.table-container .mat-mdc-cell a span {
  text-decoration: none;
}
.table-container .mat-mdc-header-cell {
  color: white;
}
a {
  text-decoration: none;
}
a:hover {
  cursor: pointer;
  border-bottom: none;
}
a:not([href]):not([tabeindex]) {
  border-bottom: 1px dotted;
}
a:not([href]):not([tabeindex]):hover {
  border-bottom: none;
}
.mat-cell {
  text-align: left;
}
.mat-row {
  border-bottom: none;
}
.mat-row:hover {
  background-color: #32333a;
}
.tip {
  text-align: left;
  background: #fffec8;
  color: black;
  padding: 20px;
  border-radius: 5px;
  position: relative;
  margin: 20px 0px;
}
.tip a {
  color: black;
}
.table-complete {
  height: 28px;
  line-height: 24px;
  text-align: center;
  background-color: transparent;
  border: none;
  width: 160px;
  color: white;
}
.table-button {
  height: 28px;
  line-height: 24px;
  text-align: center;
  background-color: transparent;
  width: 160px;
  border-radius: 15px;
  border: 1px solid white;
  color: white;
  cursor: pointer;
}
.table-button-primary {
  height: 28px;
  line-height: 24px;
  text-align: center;
  padding: 0px 10px;
  background-color: #51B498;
  width: 162px;
  border-radius: 15px;
  border: 1px solid #51B498;
  color: white;
  cursor: pointer;
}
.play-img {
  width: 22px;
  height: 20px;
  margin-bottom: 2px;
  margin-left: -5px;
}
.mat-column-doTraining {
  text-align: center;
}
.mat-column-userGuide {
  text-align: center;
}
.mat-column-preview {
  text-align: right;
}
.mat-column-previewLibrary {
  text-align: center;
}
.mat-column-copySmartURL {
  text-align: center;
}
/*# sourceMappingURL=preview-training.component.css.map */
